import Entity from "@/views/Contacts/Entity.vue";
import Contacts from "@/views/Contacts/Contacts.vue";
import Clients from "@/views/Contacts/Clients.vue";
import Suppliers from "@/views/Contacts/Suppliers.vue";
import ViewEntitys from "@/components/Contacts/ViewContacts.vue";
import CatalogueSupplier from "@/components/Contacts/CatalogueSupplier.vue";
const EntityRoute=  {
    path: "/entitys",
    name: "Entity",
    component: Entity,
    meta: {
      code: "CNN-01" // Ya está bien
    },
    meta: {
      LOGGED: true,
    },
    children: [
      {
        path: "all_contact",
        name: "Contacts",
        component: Contacts,
        meta: {
          code: "CNN-01" // Ya está bien
        },
      },
      {
        path: "clients",
        name: "Clients",
        component: Clients,
        meta: {
          code: "CNN-02" // Ya está bien
        },
      },
      {
        path: "suppliers",
        name: "Suppliers",
        component: Suppliers,
        meta: {
          code: "CNN-03" // Ya está bien
        },
      },
      {
        path: "catalogue_supplier/:id",
        name: "CatalogueSupplier",
        component: CatalogueSupplier,
         meta: {
        code: "CNN-014" // Ya está bien
      },
      },

      {
        path: "view/:id",
        name: "ViewEntitys",
        component: ViewEntitys,
        meta: {
          code: "CNN-011" // Ya está bien
        },
      },

      ,
    ],
  }

export default EntityRoute